import { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';

interface ZendeskStatusDisplayProps { ticketStatus: string }

const ZendeskStatusDisplay: FC<ZendeskStatusDisplayProps> = ({ ticketStatus }) => {
  const getStatusColor = (status: string): string => {
    switch (status) {
      case 'solved':
        return '#58A434'
      case 'open':
        return '#0B88E2';
      case 'closed':
        return '#C2C2C2';
      default:
        return '#FD9255';
    }
  }

  return (
    <Stack direction="row" sx={{ color: getStatusColor(ticketStatus) }}>
      <Typography sx={{ marginRight: '8px', textTransform: 'uppercase' }}>{ticketStatus}</Typography>
      <ZendeskStatusIcon status={ticketStatus} />
    </Stack>
  )
};

interface ZendeskStatusIconProps { status: string }

const ZendeskStatusIcon: FC<ZendeskStatusIconProps> = ({ status }) => {
  return (
    <>
      {status === 'new' && <></> }
      {status === 'open' && <></> }
      {status === 'pending' && <HistoryToggleOffIcon /> }
      {status === 'hold' && <ReportProblemIcon /> }
      {status === 'closed' && <></> }
      {status === 'solved' && <CheckBoxIcon /> }
    </>
  )
}

export default ZendeskStatusDisplay;
